module.exports = __webpack_public_path__ + "img/somos_placa_verde_en.026953f7.jpg";